import {Pipe, PipeTransform} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {
  constructor() {}

  transform(value: string, searchTerm: string): SafeHtml {
    if (!value || !searchTerm) return value;

    // 'g' flag continues after first match
    // 'i' flag makes case-insensitive
    const regex = new RegExp(searchTerm, 'gi');
    return value.replace(regex, match =>
      `<span class="highlight">${match}</span>`
    );
  }
}
